var Shopify=Shopify||{};
Shopify.money_format="${{amount}}";
Shopify.formatMoney=function(t,e){
  if("string"==typeof t){ t=t.replace(".",""); }
  var i="",a=/\{\{\s*(\w+)\s*\}\}/,s=e||this.money_format;
  function r(t,e){return void 0===t?e:t}
  function n(t,e,i,a){
    if(e=r(e,2),i=r(i,","),a=r(a,"."),isNaN(t)||null==t)return 0;
    var s=(t=(t/100).toFixed(e)).split(".");
    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(s[1]?a+s[1]:"")
  }
  switch(s.match(a)[1]){
    case"amount":i=n(t,2);break;
    case"amount_no_decimals":i=n(t,0);break;
    case"amount_with_comma_separator":i=n(t,2,".",",");break;
    case"amount_no_decimals_with_comma_separator":i=n(t,0,".",",")
  }
  return s.replace(a,i)
};

(function(t,e){
  var i=e(".wishlist-btn"),
      a=e(".wishlist-tile-container"),
      s=e(".wishlist-item-count"),
      n=localStorage.getItem("user_wishlist")||[];
  
  if(n.length>0 && typeof n === "string"){ n=JSON.parse(n); }

  // ===============================
  // Real-time header update
  // ===============================
  function updateHeader(){
    n = JSON.parse(localStorage.getItem("user_wishlist")) || [];
    var count = n.length;
    var header = e('.site-header__icon.site-header__wishlist.cro-nav-fav');
    var headerCount = header.find('.wishlist-item-count');

    if(headerCount.length){
        if(count > 0){ 
            headerCount.text(count).show(); 
            header.addClass('active'); 
        } else { 
            headerCount.text("").hide(); 
            header.removeClass('active'); 
        }
    }
  }

  // ===============================
  // Show empty state when no cards are left
  // ===============================
  function checkEmptyState(){
    if(e(".nws-wishlist-grid .grid__item").length === 0){
      e(".wishlist-grid--empty-list").addClass("is_visible");
    }
  }

  // ===============================
  // Wishlist Grid Rendering (The Wishlist Page)
  // ===============================
  var l=function(){
    window.location.href.indexOf("pages/wishlist")>-1 && (function(){
      
      var freshData = JSON.parse(localStorage.getItem("user_wishlist")) || [];

      e.each(freshData, function(index, wishlistItem) {
        var itemParts = String(wishlistItem).split(":"); 
        var productHandle = itemParts[0];
        var savedVariantId = itemParts.length > 1 ? itemParts.slice(1).join(":") : null;

        "insureship-coverage"!=productHandle && e.getJSON("/products/"+productHandle+".js", function(t){
          var titleText=t.title, s=t.url, l=0, c=0, o="";
          
          var targetVariant = t.variants[0]; 
          if(savedVariantId) {
            targetVariant = t.variants.find(function(v) { 
                return String(v.id) === String(savedVariantId) || String(v.title).trim() === String(savedVariantId).trim(); 
            }) || t.variants[0];
          }
          
          s = t.url + "?variant=" + targetVariant.id;
          
          if(targetVariant) {
            if(targetVariant.compare_at_price > targetVariant.price) {
               l=Shopify.formatMoney(targetVariant.price,"");
               c=Shopify.formatMoney(targetVariant.compare_at_price,"");
               o='<span class="ProductItem__Price Price Price--compareAt Text--subdued" style="text-decoration:line-through; color:#999; margin-right:5px;">'+c+'</span><span class="ProductItem__Price Price Price--highlight" style="color:#000; font-weight:bold;">'+l+"</span>";
            } else {
               l=Shopify.formatMoney(targetVariant.price,"");
               o='<span class="ProductItem__Price Price Price--highlight" style="color:#000; font-weight:bold;">'+l+"</span>";
            }
          }

          var d=t.media, h="";
          e(d).each(function(idx,media){ 
            idx<1 && (h=('<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[600,700,800,900,1000,1200]" data-sizes="auto" alt="'+titleText+'" title="'+titleText+'" data-media-id="'+media.id+'" sizes="410px" src="'+media.src+'">').replace(".jpg","_500x.jpg").replace(".png","_500x.png").replace(".jpeg","_500x.jpeg").replace(".webp","_500x.webp").replace(".gif","_500x.gif")) 
          });
          
          var dropdownHTML = "";
          if(t.variants.length > 1 && t.variants[0].title !== "Default Title") {
            dropdownHTML = `<select class="wishlist-variant-selector" style="width: 100%; padding: 10px; margin-bottom: 15px; border-radius: 4px; border: 1px solid #ddd; font-size: 14px; background: #fff; cursor: pointer; outline: none;">`;
            
            e(t.variants).each(function(idx, variant) {
              var isSelected = (String(variant.id) === String(targetVariant.id)) ? "selected" : "";
              var vSalePrice = Shopify.formatMoney(variant.price, "");
              var vComparePrice = variant.compare_at_price > variant.price ? Shopify.formatMoney(variant.compare_at_price, "") : "";
              dropdownHTML += `<option value="${variant.id}" data-price="${vSalePrice}" data-compare="${vComparePrice}" ${isSelected}>${variant.title}</option>`;
            });
            dropdownHTML += `</select>`;
          }

          var productCardHTML = `
            <div class="grid__item" style="width: 25%; padding: 15px; box-sizing: border-box; display: inline-block; vertical-align: top; min-width: 280px;">
              <div class="ProductItem__Wrapper" style="background-color: #ffffff; border-radius: 8px; padding: 20px; text-align: center; position: relative; box-shadow: 0 4px 10px rgba(0,0,0,0.05);">

                <button class="nws-wishlist-btn" data-product-base-handle="${t.handle}" style="position: absolute; top: 15px; right: 15px; width: 30px; height: 30px; background: #000000; border: none; border-radius: 50%; box-shadow: 0 2px 5px rgba(0,0,0,0.2); display: flex; align-items: center; justify-content: center; cursor: pointer; z-index: 10; padding: 0; transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1); will-change: transform;" aria-label="Remove from wishlist">
                  <svg viewBox="0 0 24 24" width="14" height="14" stroke="#ffffff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
                
                <div class="ws-sale-badge" style="display:none;"></div>
                
                <a href="${s}" class="ProductItem__ImageWrapper wishlist-product-link" style="display: block; margin-bottom: 20px; text-align: center;">
                  <div style="height: 100px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                    ${h}
                  </div>
                </a>
                <div class="ProductItem__Info">
                  <h2 class="ProductItem__Title" style="font-size: 18px; font-weight: 400; color: #000; margin-bottom: 10px; line-height: 1.3; min-height: 46px;">
                    <a href="${s}" class="wishlist-product-link" style="color: inherit; text-decoration: none;">${titleText}</a>
                  </h2>
                  <div style="margin-bottom: 10px; font-size: 14px; color: #000;">★★★★★ <span style="font-size: 13px; color: #555;">Reviews</span></div>
                  
                  ${dropdownHTML} 
                  
                  <div class="ProductItem__PriceList" style="margin-bottom: 15px; font-size: 16px;">${o}</div>
                  
                  <a href="${s}" class="Button Button--primary wishlist-view-btn" style="display: block; width: 100%; background-color: #F94515; color: white; padding: 12px; text-decoration: none; border-radius: 4px; font-weight: bold; font-size: 14px; text-transform: uppercase;">View Product</a>
                  
                </div>
              </div>
            </div>
          `;

          e(".nws-wishlist-grid").append(productCardHTML);
          
          e(document).off("change", ".nws-wishlist-grid .wishlist-variant-selector").on("change", ".nws-wishlist-grid .wishlist-variant-selector", function(){
             var selectedOpt = e(this).find('option:selected');
             var newId = selectedOpt.val();
             var newPrice = selectedOpt.attr('data-price');
             var newCompare = selectedOpt.attr('data-compare');
             var card = e(this).closest('.ProductItem__Wrapper');
             var baseHandle = card.find('.nws-wishlist-btn').attr('data-product-base-handle');
             
             var priceContainer = card.find('.ProductItem__PriceList');
             if(newCompare !== "") {
                priceContainer.html('<span class="ProductItem__Price Price Price--compareAt Text--subdued" style="text-decoration:line-through; color:#999; margin-right:5px;">'+newCompare+'</span><span class="ProductItem__Price Price Price--highlight" style="color:#000; font-weight:bold;">'+newPrice+'</span>');
                card.find('.ws-sale-badge').show();
             } else {
                priceContainer.html('<span class="ProductItem__Price Price Price--highlight" style="color:#000; font-weight:bold;">'+newPrice+'</span>');
                card.find('.ws-sale-badge').hide();
             }
             
             var baseUrl = card.find('.wishlist-view-btn').attr('href').split('?variant=')[0];
             var newUrl = baseUrl + "?variant=" + newId;
             card.find('.wishlist-view-btn').attr('href', newUrl);
             card.find('a.wishlist-product-link').attr('href', newUrl);

             var currentStorage = JSON.parse(localStorage.getItem("user_wishlist")) || [];
             for (var k = 0; k < currentStorage.length; k++) {
                 if (String(currentStorage[k]).split(':')[0] === baseHandle) {
                     currentStorage[k] = baseHandle + ":" + newId;
                     break;
                 }
             }
             localStorage.setItem("user_wishlist", JSON.stringify(currentStorage));
          });

          e(document).off("click", ".nws-wishlist-grid .nws-wishlist-btn").on("click", ".nws-wishlist-grid .nws-wishlist-btn", function(event){
            event.preventDefault();
            var targetHandle = e(this).attr("data-product-base-handle");
            var currentStorage = JSON.parse(localStorage.getItem("user_wishlist")) || [];
            currentStorage = e.grep(currentStorage, function(item){ return String(item).split(':')[0] != targetHandle }); 
            localStorage.setItem("user_wishlist", JSON.stringify(currentStorage));
            e(this).closest('.grid__item').fadeOut(300, function() { 
              e(this).remove(); 
              updateHeader(); 
              checkEmptyState();
            });
          });
        });
      });
    })();

    e(".wishlist-loader").fadeOut(2e3,function(){ 
      e(".wishlist-grid").addClass("is_visible"); 
      e(".wishlist-hero").addClass("is_visible"); 
      var finalCheck = JSON.parse(localStorage.getItem("user_wishlist")) || [];
      (finalCheck.length === 0) ? e(".wishlist-grid--empty-list").addClass("is_visible") : e(".wishlist-grid--empty-list").hide(); 
    });
  };

  // ===============================
  // Add to Wishlist Click Logic
  // ===============================
  var c=function(){
    i.click(function(t){
      t.preventDefault();
      var $btn = e(this);
      var handle = $btn.attr("data-product-handle");
      var finalVariantId = null;

      var freshString = localStorage.getItem("user_wishlist") || "[]";
      var freshStorage = [];
      try { freshStorage = JSON.parse(freshString); } catch(err) {}

      var productCard = $btn.closest('product-card, .product-card, .grid__item, .product-item, .card-wrapper, .product-grid__card'); 
      
      if (productCard.length > 0) {
        // STRATEGY 1: Visual Reader
        var visibleSelects = productCard.find('select');
        if (visibleSelects.length > 0) {
            var firstVal = visibleSelects.first().val();
            if (firstVal && /^\d{8,}$/.test(firstVal)) {
                finalVariantId = firstVal; 
            } else {
                var selectedTexts = [];
                visibleSelects.each(function() {
                    var txt = e(this).find('option:selected').text().trim();
                    if(txt) selectedTexts.push(txt);
                });
                if (selectedTexts.length > 0) {
                    finalVariantId = selectedTexts.join(' / '); 
                }
            }
        }

        // STRATEGY 2: Fallback to URL observer data injection
        if (!finalVariantId) {
            var syncId = $btn.attr("data-variant-id");
            if (syncId && /^\d{8,}$/.test(syncId)) {
                finalVariantId = syncId;
            }
        }

        // STRATEGY 3: Hidden Forms Check
        if (!finalVariantId) {
            var cardForm = productCard.find('form[action*="/cart/add"]');
            if (cardForm.length > 0) {
                var formVal = cardForm.find('input[name="id"], select[name="id"]').val();
                if (formVal && /^\d{8,}$/.test(formVal)) {
                    finalVariantId = formVal;
                }
            }
        }
      }

      // STRATEGY 4: Product Page URL Params
      if (!finalVariantId) {
         var urlParams = new URLSearchParams(window.location.search);
         finalVariantId = urlParams.get('variant');
      }
      
      var combinedId = finalVariantId ? handle + ":" + finalVariantId : handle;

      if($btn.hasClass("is-active")){
        freshStorage = e.grep(freshStorage, function(item) { return String(item).split(':')[0] != handle }); 
        localStorage.setItem("user_wishlist", JSON.stringify(freshStorage));
      }else{
        freshStorage = e.grep(freshStorage, function(item) { return String(item).split(':')[0] != handle }); 
        freshStorage.push(combinedId); 
        localStorage.setItem("user_wishlist", JSON.stringify(freshStorage));
      }
      $btn.toggleClass("is-active");
      updateHeader(); 
    });
  };

  t.init=function(){
    c();
    i.each(function(){ 
      var t=e(this).attr("data-product-handle"); 
      var freshStorage = JSON.parse(localStorage.getItem("user_wishlist")) || [];
      var isActive = freshStorage.some(function(item) { return String(item).split(':')[0] === t; });
      if(isActive){ e(this).addClass("is-active"); }
    });
    l();
    updateHeader(); 
  };

})(window.Wishlist=window.Wishlist||{}, jQuery);

$(document).ready(function() { window.Wishlist.init(); });

// ===============================
// Variant URL Observer for Product Page
// ===============================
$(document).ready(function() {
  function updateWishlistButtonVariant() {
    var urlParams = new URLSearchParams(window.location.search);
    var currentVariant = urlParams.get('variant');
    var wishlistBtns = document.querySelectorAll('.wishlist-btn'); 
    
    if (currentVariant && wishlistBtns.length > 0 && window.location.href.indexOf('/products/') > -1) {
      wishlistBtns.forEach(function(btn) {
        btn.setAttribute('data-variant-id', currentVariant);
      });
    }
  }

  updateWishlistButtonVariant();

  var pushState = history.pushState;
  history.pushState = function() {
      pushState.apply(history, arguments);
      setTimeout(updateWishlistButtonVariant, 100); 
  };
  
  var replaceState = history.replaceState;
  history.replaceState = function() {
      replaceState.apply(history, arguments);
      setTimeout(updateWishlistButtonVariant, 100);
  };
  
  window.addEventListener('popstate', updateWishlistButtonVariant);
});